import { type FC } from 'react';
import { graphql, useFragment } from 'react-relay';
import { handleLocaleUrl, GLOBAL_CLIENT_ONLY_LOCALE } from 'dibs-intl/exports/urls';
import * as tracking from 'dibs-tracking';

import { PdpSharedDetail, type PdpSharedDetailProps } from './PdpSharedDetail';

import { type PdpSharedDetailMovement_detailValues$data as DataType } from './__generated__/PdpSharedDetailMovement_detailValues.graphql';
import { type ArrayElement } from 'dibs-ts-utils/exports/ArrayElement';

const handleClick = (browseUrl?: ArrayElement<NonNullable<DataType>>['browseUrl']): void => {
    tracking.trackEvent({
        category: 'product',
        action: 'view movement descriptions click',
        label: 'watch attribute',
        eventName: 'product_interaction',
        isInteractiveEvent: true,
        step_interaction_name:
            tracking.stepInteractionConstants.STEP_INTERACTION_VIEW_MOVEMENT_DESCRIPTION_CLICK,
        interaction_type: tracking.interactionTypeConstants.INTERACTION_TYPE_WATCH_ATTRIBUTE,
    });
    window.location.href = handleLocaleUrl(browseUrl || '', GLOBAL_CLIENT_ONLY_LOCALE);
};

export const PdpSharedDetailMovement: FC<PdpSharedDetailProps> = props => {
    const detailValues = useFragment(
        graphql`
            fragment PdpSharedDetailMovement_detailValues on PdpDetailValueInterface
            @relay(plural: true) {
                detailKey
                browseUrl
            }
        `,
        props.detailValues
    );

    return (
        <PdpSharedDetail
            {...props}
            onClickMap={{
                movement: {
                    clickFn: () => handleClick(detailValues?.[0]?.browseUrl),
                    dataTn: 'click-movement-label',
                },
            }}
        />
    );
};
